import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import { CAMPAIGN_ENTITY_VARIANTS } from "./campaignEntityStyles"

/**
 * Centered placeholder for missing campaign data on Settings → Campaign.
 *
 * @param {object} props
 * @param {"recruitingProfile" | "leadTargeting"} [props.variant]
 * @param {React.ReactNode} props.icon
 * @param {string} props.title
 * @param {React.ReactNode} props.children
 */
export default function CampaignEmptyState({
  variant = "recruitingProfile",
  icon,
  title,
  children,
}) {
  const theme = useTheme()
  const meta = CAMPAIGN_ENTITY_VARIANTS[variant]
  const accent =
    theme.palette.colors?.[meta.accent] ?? theme.palette.primary.main
  const border = theme.palette.colors?.[meta.border] ?? theme.palette.divider
  const surface = theme.palette.colors?.[meta.surface]

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        py: 3.5,
        px: 2.5,
        borderRadius: 2,
        border: `1px dashed ${border}`,
        bgcolor: surface ? `${surface}66` : "action.hover",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 52,
          height: 52,
          borderRadius: "50%",
          mb: 1.5,
          color: accent,
          bgcolor: "background.paper",
          border: `1px solid ${border}`,
          boxShadow: `0 2px 8px -2px ${accent}33`,
          "& .MuiSvgIcon-root": { fontSize: 28 },
        }}
      >
        {icon}
      </Box>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.75 }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 420, lineHeight: 1.55 }}
      >
        {children}
      </Typography>
    </Box>
  )
}
